export default {"src":"/_next/static/media/MSI.e3616106.svg","height":18,"width":18};